import React, { useContext } from 'react';
import moment from 'moment';

import { HandleAddActivity } from './requests/ActivityRequests';

import { DataContext as SharedDataContext } from '../../stores/crm-store';
import GenericFormModal from './shared/GenericFormModal';
import EditText from './shared/field_inputs/text/EditText';
import EditTextArea from './shared/field_inputs/text/EditTextArea';
import EditType from './shared/field_inputs/type/EditType';
import EditItem from './shared/field_inputs/item/EditItem';
import EditItemList from './shared/field_inputs/item_list/EditItemList';
import EditDate from './shared/field_inputs/date/EditDate';
import { createGetSuggestionsFromApiUrl } from './shared/field_inputs/HelpMethods';

const AddActivity = () => {
    const { store } = useContext(SharedDataContext);
    const { ActivityTypeOptions } = store;

    const defaultFormValues =
        store.areSelectOptionsFetched && ActivityTypeOptions.length
            ? {
                  name: ActivityTypeOptions[0].name,
                  activityType: ActivityTypeOptions[0],
                  date: moment().format('YYYY-MM-DD'),
              }
            : {};

    const formComponents = [
        {
            propName: 'name',
            label: 'Titel',
            validate: (v) => (!v || !v.length ? 'Fyll i namn.' : ''),
            bindOnChange: (values, changedPropName) => {
                if (!changedPropName === 'type') return;
                if (!ActivityTypeOptions.some((t) => t.name === values.name)) return;
                if (values.type) {
                    return values.type.name;
                }
            },
            component: <EditText autoFocus />,
        },
        {
            propName: 'activityType',
            validate: (v) => (!v ? 'Välj typ.' : ''),
            component: <EditType options={ActivityTypeOptions} size='sm' />,
        },
        {
            propName: 'notes',
            label: 'Notat',
            validate: (v) => (v?.length && v.length > 200 ? 'Max 200 karaktärer.' : ''),
            component: <EditTextArea maxLength={200} />,
        },
        {
            propName: 'date',
            label: 'Datum',
            component: <EditDate />,
        },
        {
            propName: 'deal',
            label: 'Deal',
            component: (
                <EditItem
                    iconName='deal'
                    isClearable
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/crmDealFront/getDealSuggestions')}
                />
            ),
        },
        {
            propName: 'persons',
            label: 'Personer',
            validate: (v) => (!v || !v.length ? 'Välj personer.' : ''),
            bindOnChange: (values, changedPropName) => {
                if (changedPropName === 'deal' && values.deal?.linkedPersonItem) {
                    if (values.persons?.length) return values.persons.concat([values.deal.linkedPersonItem]);
                    return [values.deal.linkedPersonItem];
                }
            },
            component: (
                <EditItemList
                    iconName='people'
                    isClearable
                    isCreationPermitted
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/crmPersonFront/getPersonSuggestions')}
                />
            ),
        },
        {
            propName: 'organization',
            label: 'Organisation',
            validate: (v) => (!v ? 'Välj företag.' : ''),
            bindOnChange: (values, changedPropName) => {
                if (changedPropName === 'persons') {
                    if (values.organization || !values.persons) return;
                    if (values.persons.length && values.persons[0].linkedOrganizationItem) {
                        return values.persons[0].linkedOrganizationItem;
                    }
                } else if (changedPropName === 'deal') {
                    if (values.organization || !values.deal) return;
                    if (values.deal.linkedOrganizationItem) {
                        return values.deal.linkedOrganizationItem;
                    }
                }
            },
            component: (
                <EditItem
                    iconName='organization'
                    isClearable
                    isCreationPermitted
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/crmOrganizationFront/getOrganizationSuggestions')}
                />
            ),
        },
    ];

    const handleAdd = async (activity) => {
        // TODO: Add to store after activity-table and virtual scrolling merge
        activity.ActivityPersons = [];
        activity.persons.forEach((p) => {
            let activityPerson = {
                personId: p.id,
            };
            activity.ActivityPersons.push(activityPerson);
        });
        return await HandleAddActivity(activity);
    };

    return (
        <GenericFormModal
            label='+ Aktivitet'
            description='Lägg till ny Aktivitet'
            formComponents={formComponents}
            handleAdd={handleAdd}
            defaultFormValues={defaultFormValues}
        />
    );
};

export default AddActivity;
